<div
    class="insight-trend"
    [ngClass]="[className || '', gridClassName || '']"
>
    <cmps-wait-status
        [absolute]="true"
        *ngIf="hasPendingData"
    ></cmps-wait-status>

    <div
        class="d-flex align-items-center justify-content-center"
        *ngIf="!hasPendingData && (!chartData || chartData.length === 0)"
    >
        {{ i18n._711_NO_DATA_AVAILABLE | translate }}
    </div>

    <div
        aria-hidden="true"
        *ngIf="!hasPendingData && chartData && chartData.length !== 0"
    >
        <ng-chart-axis
            [options]="chartOpts"
            [data]="chartData"
            #axis="ngChartAxis"
        ></ng-chart-axis>
    </div>
</div>
